export const integratorsContactTypes = {
	BUSINESS: 1,
	SUPPORT: 2,
	INTERNAL: 3,
	TECHNICAL: 4
};

Object.freeze(integratorsContactTypes);
